"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _reactSwipeableViews = _interopRequireDefault(require("react-swipeable-views"));

var _reactSwipeableViewsUtils = require("react-swipeable-views-utils");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Tabs = _interopRequireDefault(require("@material-ui/core/Tabs"));

var _Tab = _interopRequireDefault(require("@material-ui/core/Tab"));

var _Storyblok = _interopRequireDefault(require("../../utils/Storyblok"));

var _customProps = require("../../utils/customProps");

var _geoLocate = require("../../utils/geoLocate");

var _customComponents = require("../../utils/customComponents");

var _MuiIcon = _interopRequireDefault(require("../MuiIcon/MuiIcon"));

var _MuiGrid = _interopRequireDefault(require("../MuiGrid/MuiGrid"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var AutoPlaySwipeableViews = (0, _reactSwipeableViewsUtils.autoPlay)(_reactSwipeableViews.default);

var MuiGeoLocationTabs = function MuiGeoLocationTabs(_ref) {
  var rootClass = _ref.rootClass,
      indicatorColor = _ref.indicatorColor,
      orientation = _ref.orientation,
      scrollButtons = _ref.scrollButtons,
      textColor = _ref.textColor,
      variant = _ref.variant,
      tabs = _ref.tabs,
      autoplay = _ref.autoplay,
      interval = _ref.interval,
      googleApiKey = _ref.googleApiKey,
      height = _ref.height,
      justifyContent = _ref.justifyContent;
  var components = {
    MuiGrid: _MuiGrid.default,
    MuiIcon: _MuiIcon.default
  };

  var _useState = (0, _react.useState)({
    autoplay: autoplay,
    tabsLength: tabs.length
  }),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      tabValue = _useState4[0],
      setTabValue = _useState4[1];

  var _useState5 = (0, _react.useState)(googleApiKey),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      googleKey = _useState6[0],
      setGoogleApiKey = _useState6[1];

  var handleChange = function handleChange(event, newValue) {
    setTabValue(newValue);
  };

  (0, _react.useEffect)(function () {
    setGoogleApiKey(googleApiKey);
  }, [googleApiKey]);
  var flexStyle = (0, _styles.makeStyles)(function () {
    return {
      flexContainer: {
        justifyContent: justifyContent
      }
    };
  });

  var handleChangeIndex = function handleChangeIndex() {
    var tabsLength = tabs.length - 1;

    if (tabValue >= tabsLength) {
      return handleChange({}, 0);
    }

    return handleChange({}, tabValue);
  };

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass, {
    flexContainer: {
      justifyContent: 'space-around'
    }
  });

  var flexClass = flexStyle();

  var onMouseEnter = function onMouseEnter() {
    if (autoplay) setState(_objectSpread(_objectSpread({}, state), {}, {
      autoplay: false
    }));
  };

  var onMouseLeave = function onMouseLeave() {
    if (autoplay) setState(_objectSpread(_objectSpread({}, state), {}, {
      autoplay: true
    }));
  };

  (0, _geoLocate.useSetGeoCode)(true, tabs, setTabValue, googleKey);
  return /*#__PURE__*/_react.default.createElement("div", {
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    style: {
      flexGrow: 1,
      display: orientation === 'vertical' ? 'flex' : 'block'
    }
  }, /*#__PURE__*/_react.default.createElement(_Tabs.default, {
    value: tabValue,
    className: styles.root,
    classes: flexClass,
    onChange: handleChange,
    indicatorColor: indicatorColor,
    orientation: orientation,
    scrollButtons: scrollButtons,
    textColor: textColor,
    variant: variant
  }, tabs.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_Tab.default, {
      key: index,
      id: index,
      onClick: function onClick(e) {
        return handleChange(e, index);
      },
      className: styles.root,
      label: item.label,
      disableFocusRipple: item.disableFocusRipple === 'true',
      disableRipple: item.disableRipple,
      wrapped: item.wrapped,
      icon: item.icon && item.icon[0] && /*#__PURE__*/_react.default.createElement(_MuiIcon.default, item.icon[0])
    });
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: height
    }
  }, tabs.map(function (tab, index) {
    return /*#__PURE__*/_react.default.createElement(AutoPlaySwipeableViews, {
      key: index,
      index: tabValue.toString() // throws warrning for invalid prop in AutoPlay expected number but view will now display when value is 0
      ,
      onChangeIndex: handleChangeIndex,
      autoplay: autoplay,
      interval: typeof interval === 'string' ? Number(interval) : interval,
      enableMouseEvents: true,
      id: "swipeableViews-test"
    }, /*#__PURE__*/_react.default.createElement("div", {
      role: "tabpanel",
      hidden: tabValue !== index,
      style: {
        overflow: 'hidden'
      }
    }, tab.content.map(function (component, key) {
      return (0, _customComponents.renderComponents)(components, component, key);
    })));
  })));
};

var _default = MuiGeoLocationTabs;
exports.default = _default;
MuiGeoLocationTabs.propTypes = {
  /**
   * storyblok multiselect of css classes
   * Override or extend the styles applied to the component
   * */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * mui prop : 'secondary', 'primary'
   * Determines the color of the indicator.
   */
  indicatorColor: function indicatorColor(props, propName, componentName) {
    var validProps = ['secondary', 'primary'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /**
   * mui prop: 'horizontal', 'vertical'
   * The tabs orientation (layout flow direction).
   */
  orientation: function orientation(props, propName, componentName) {
    var validProps = ['horizontal', 'vertical'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /**
   * Height of the tabs container.
   */
  height: function height(props, propName, componentName) {
    return (0, _customProps.dimensionProp)(props, propName, componentName);
  },

  /**
   * mui prop: 'auto', 'desktop', 'on', 'off'
   * Determine behavior of scroll buttons when tabs are set to scroll:
   * - auto will only present them when not all the items are visible.
   * - desktop will only present them on medium and larger viewports.
   * - on will always present them.
   * - off will never present them.
   */
  scrollButtons: function scrollButtons(props, propName, componentName) {
    var validProps = ['auto', 'desktop', 'on', 'off'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /**
   * mui prop: 'secondary', 'primary', 'inherit'
   * Determines the color of the Tab.
   */
  textColor: function textColor(props, propName, componentName) {
    var validProps = ['secondary', 'primary', 'inherit'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /**
   * mui prop:  'standard', 'scrollable', 'fullWidth'
   * Determines additional display behavior of the tabs:
   * - scrollable will invoke scrolling properties and allow for
    horizontally scrolling (or swiping) of the tab bar.
   * -fullWidth will make the tabs grow to use all the available space,
    which should be used for small views, like on mobile.
    - standard will render the default state.
   */
  variant: function variant(props, propName, componentName) {
    var validProps = ['standard', 'scrollable', 'fullWidth'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /**
   * Justify content flex styling for MuiGeoLocationTabs.
   * justifyContent: 'space-between', 'center', 'space-evenly', 'space-around'
   */
  justifyContent: function justifyContent(props, propName, componentName) {
    var validProps = ['space-between', 'center', 'space-evenly', 'space-around'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /** autoplay will incroment tabs by a interval */
  autoplay: _propTypes.default.bool,

  /** interval to increment tabs: time in milliseconds */
  interval: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** key for googleApisKey to use geocode */
  googleApiKey: _propTypes.default.string,

  /** MuiTab */
  tabs: function tabs(props, propName, componentName) {
    var components = ['MuiTab'];
    return (0, _customProps.validComponents)(props, propName, componentName, components);
  }
};
MuiGeoLocationTabs.defaultProps = {
  rootClass: [],
  tabs: [],
  indicatorColor: 'secondary',
  orientation: 'vertical',
  scrollButtons: 'auto',
  textColor: 'inherit',
  variant: 'standard',
  autoplay: false,
  interval: 3000,
  height: '300px',
  justifyContent: 'center',
  googleApiKey: ''
};